import React from "react"
import { Wave } from "react-animated-text"
import styles from "./Team.module.css"
import EventIllustration from "./EventIllustration"

const EventTeam = () => {
  const [width, setWidth] = React.useState()
  React.useEffect(() => {
    setWidth(window.innerWidth)
  }, [])
  const updateDimensions = () => {
    setWidth(window.innerWidth)
  }
  const updateWidth = () => {
    setWidth(window.innerWidth)
  }

  React.useEffect(() => {
    window.addEventListener("resize", updateWidth)
    return () => {
      window.removeEventListener("resize", updateDimensions)
    }
  }, [width])
  const text = `Events Team`
  return (
    <div className={styles.container}>
      <div className={styles.subContainer}>
        <span className={styles.heading}>
          <Wave text={text} effect="stretch" iterations={1} effectChange={2} />
        </span>
        {width <= 768 && <EventIllustration />}
        <span className={styles.para}>
          {" "}
          While the content and design of the front-end activity of the Club,
          here comes the Club's backend. Events vertical will manage & organize
          the events, webinars, and workshops of our Club. You're going to
          benefit from managerial skills, event planning & hosting here. The
          more you spend your valuable time and knowledge here, the more
          marketing, public speaking & public relations skills you get. Finally,
          you will get connected with alumni and industry experts here. &nbsp;
          <a href="/team/event_team" rel="noreferrer">
            Know More...
          </a>
        </span>
      </div>
      {width > 768 && <EventIllustration />}
    </div>
  )
}

export default EventTeam
